import React from 'react'
import { Raw, Editor } from 'slate'
import { getPlugins, defaultStyle } from './Editor'

const ContentSection = ({ content, ...restProps }) => (
  <Editor
    selectedStyle={defaultStyle}
    plugins={getPlugins()}
    state={Raw.deserialize(content, { terse: true })}
    readOnly
    {...restProps}
  />
)

export default ContentSection



// WEBPACK FOOTER //
// ./src/components/ContentSection.js